import loadable from '@loadable/component';

const FilterSection = loadable(
  () =>
    import(
      /* webpackChunkName: "product-collection-filter" */ './filter-section'
    )
);

export * from './types';
export * from './utils';

export default FilterSection;
